<script setup>
import { __ } from '@/utils';
import Hint from "@components/hint.vue";
import IconFireworks from '../../icons/icon-fireworks.vue';

// cleanup
localStorage.removeItem('formValues');
localStorage.removeItem('formFragmentValues');
</script>
<template>
    <div class="step-heading align-center">
        <div class="step-heading__icon">
            <IconFireworks />
        </div>
        <h3 class="gradient"><strong>{{ __('Congratulations, ') }}</strong></h3>
        <h3><strong>{{ __('Process successfuly completed!') }}</strong></h3>
    </div>
    <p class="align-center"><strong>{{ __('Still struggling? Use our guides') }}</strong></p>
    
    <div class="guide-cta">
        <div class="guide-cta__item">
            <Hint :hint="{title: 'lorem','description': 'lorem'}" />
            <button type="button">
                {{ __('Android Guide') }}
            </button>
        </div>
        <div class="guide-cta__item">
            <Hint :hint="{title: 'lorem','description': 'lorem'}" />
            <button type="button">
                {{ __('IOS Guide') }}
            </button>
        </div>
    </div>
    
    <div class="step-box__center-cta">
        <a href="/" class="btn btn--arrows">
            {{ __('Back to Home page') }}
        </a>
    </div>
</template>